import { Dialog, notifyError, notifySuccess } from '@/components'
import UnitSelect from '@/modules/add-new-unit/components/UnitSelect/UnitSelect'
import {
  useAddNewDitUnitMutation,
  useAddNewLightningUnitMutation,
} from '@/modules/add-new-unit/services/newUnitService'
import Input from '@/modules/organization/components/Input/Input'
import { UserTypes } from '@/types/typeUser'
import TimePicker from '@/modules/aqua-device-module/components/actions/ui/TimePicker'
import UploadFeaturesDoc from '@/components/Organisms/UploadFeaturesDoc/UploadFeaturesDoc'
import UploadFeaturesDocList from '@/components/Organisms/UploadFeaturesDoc/UploadFeaturesDocList'
import DeleteDeviceButton from '@/modules/device-module/components/deleteDeviceButton/deleteDeviceButton'
import UploadFeaturesImg from '@/components/Organisms/UploadFeaturesImg/UploadFeaturesImg'
import { useChangeSet } from '@/utils/useChangeSet'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup'
import { LoadingButton } from '@mui/lab'
import {
  Box,
  Typography,
  InputAdornment,
  Link,
  Stack,
  Grid,
} from '@mui/material'
import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import * as Yup from 'yup'
import MapLightnings from '@/components/Organisms/Map/MapLightnings'
import { AddNewLightningUnitReq } from '@/modules/add-new-unit/types/newUnitType'
import CustomSelect from '@/components/CustomSelect/CustomSelect'
import {
  IUnitsFields,
  systemStatusSelect,
} from '@/modules/add-new-tsodd/components/UnitData/UnitData'
import DatePickers from '@/modules/user/components/DatePicker/DatePicker'
import Asynchronous from '@/modules/add-new-dtp/components/Autocompleter'
import dayjs, { Dayjs } from 'dayjs'
import MapDTPProvider from '@/components/Organisms/Map/MapDTPProvider'
import {
  useUpdateTrafficAccidentMutation,
  UpdateTrafficAccidentRequest,
} from '@/modules/add-new-dtp/components/dtpService'

interface DtpFormFields extends IUnitsFields {
  number?: string
  accidentDate?: Dayjs | string | null
  typeId?: number | ''
  regionId?: number | ''
  district?: string | null
  roadKilometer?: number | null
  roadMeter?: number | null
  latitude?: number
  longitude?: number
  dead?: number | null
  deadChildren?: number | null
  injured?: number | null
  injuredChildren?: number | null
  lightingTypeId?: number | ''
  areaTypeId?: number | ''
  // clusters: any
}

type Props = {
  // formValues: any
  // units: any
  //
  currentUserType: number
  // documents: any
  inputsData: any
  refetch: () => void
}
const validationSchema = Yup.object().shape({
  number: Yup.string()
    .required('Номер не может быть пустым')
    .trim('Номер не может быть пустым')
    .max(12, 'Не более 12 символов'),
  latitude: Yup.number().required('Укажите широту').typeError('Укажите широту'),
  longitude: Yup.number()
    .required('Укажите долготу')
    .typeError('Укажите долготу'),
  dead: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ||
        originalValue === null ||
        originalValue === undefined
        ? null
        : value
    })
    .integer('Только целые числа')
    .min(0, '')
    .typeError('Введите корректное число'),
  deadChildren: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ||
        originalValue === null ||
        originalValue === undefined
        ? null
        : value
    })
    .integer('Только целые числа')
    .min(0, '')
    .test('max-dead', 'Общее количество меньше', function (value) {
      if (value === null || value === undefined) return true
      const dead = this.parent.dead
      if (dead === null || dead === undefined) return true
      return value <= dead
    })
    .typeError('Введите корректное число'),
  injured: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ||
        originalValue === null ||
        originalValue === undefined
        ? null
        : value
    })
    .integer('Только целые числа')
    .min(0, '')
    .typeError('Введите корректное число'),
  injuredChildren: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ||
        originalValue === null ||
        originalValue === undefined
        ? null
        : value
    })
    .integer('Только целые числа')
    .min(0, '')
    .test('max-injured', 'Общее количество меньше', function (value) {
      if (value === null || value === undefined) return true
      const injured = this.parent.injured
      if (injured === null || injured === undefined) return true
      return value <= injured
    })
    .typeError('Введите корректное число'),
})

const FeaturesDTPForm: React.FC<Props> = ({
  refetch,
  inputsData,
  currentUserType,
}) => {
  const gridItemProps = {
    item: true,
    xss: 12,
    mdx: 12,
    xl: 6,
    xl4: 6,
  }
  const gridContainerProps = {
    container: true,
    spacing: 1.8,
    sx: {
      mb: 2,
    },
  }
  const getTimeFromDate = (dateString: string | null | undefined): string => {
    if (!dateString) return '00:00:00'
    try {
      const date = new Date(dateString)
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${hours}:${minutes}:${seconds}`
    } catch {
      return '00:00:00'
    }
  }

  const [openDialogSave, setOpenDialogSave] = useState(false)
  const [formChanged, setFormChanged] = useState(false)
  const { id } = useParams()
  const [roadState, setRoadState] = useState(inputsData?.road || '')
  const [timeState, setTimeState] = useState(
    getTimeFromDate(inputsData?.accidentDate)
  )
  const [newCoords, setNewCoords] = useState<number[]>([
    inputsData?.latitude || 0,
    inputsData?.longitude || 0,
  ])
  const isUpdatingFromMapRef = useRef(false)
  const prevFormCoordsRef = useRef<number[]>([
    inputsData?.latitude || 0,
    inputsData?.longitude || 0,
  ])

  const isDisabled = currentUserType !== UserTypes.superAdmin

  const defaultValues: DtpFormFields = {
    name: '',
    number: inputsData?.number,
    address: '',
    systemId: '',
    dead: inputsData?.dead || 0,
    deadChildren: inputsData?.deadChildren || 0,
    injured: inputsData?.injured || 0,
    injuredChildren: inputsData?.injuredChildren || 0,
    latitude: inputsData?.latitude,
    longitude: inputsData?.longitude,
    accidentDate: inputsData?.accidentDate
      ? dayjs(inputsData.accidentDate)
      : null,
    typeId: inputsData?.typeId || '',
    regionId: inputsData?.regionId || '',
    district: inputsData?.district || '',
    roadKilometer: inputsData?.roadKilometer,
    roadMeter: inputsData?.roadMeter,
    lightingTypeId: inputsData?.lightingTypeId || '',
    areaTypeId: inputsData?.areaTypeId || '',
  }

  const {
    handleSubmit,
    control,
    trigger,
    formState,
    watch,
    setValue,
    reset,
    getValues,
  } = useForm<DtpFormFields>({
    defaultValues,
    resolver: yupResolver(validationSchema),
    criteriaMode: 'all',
    mode: 'onChange',
    reValidateMode: 'onChange',
  })

  const handleChangeCoords = (coords: number[]) => {
    if (coords && coords.length >= 2 && !isDisabled) {
      isUpdatingFromMapRef.current = true
      setNewCoords(coords)
    }
  }

  const watchedLatitude = watch('latitude')
  const watchedLongitude = watch('longitude')
  const watchedNumber = watch('number')

  useEffect(() => {
    if (inputsData) {
      reset({
        name: '',
        number: inputsData?.number,
        address: '',
        systemId: '',
        dead: inputsData?.dead || 0,
        deadChildren: inputsData?.deadChildren || 0,
        injured: inputsData?.injured || 0,
        injuredChildren: inputsData?.injuredChildren || 0,
        latitude: inputsData?.latitude,
        longitude: inputsData?.longitude,
        accidentDate: inputsData?.accidentDate
          ? dayjs(inputsData.accidentDate)
          : null,
        typeId: inputsData?.typeId || '',
        regionId: inputsData?.regionId || '',
        district: inputsData?.district || '',
        roadKilometer: inputsData?.roadKilometer,
        roadMeter: inputsData?.roadMeter,
        lightingTypeId: inputsData?.lightingTypeId || '',
        areaTypeId: inputsData?.areaTypeId || '',
      })
      if (inputsData?.road) {
        setRoadState(inputsData.road)
      }
      setTimeState(getTimeFromDate(inputsData?.accidentDate))
      const initialCoords = [
        inputsData?.latitude || 0,
        inputsData?.longitude || 0,
      ]
      setNewCoords(initialCoords)
      prevFormCoordsRef.current = initialCoords
    }
  }, [inputsData, reset])

  useEffect(() => {
    if (newCoords && newCoords.length >= 2 && isUpdatingFromMapRef.current) {
      setValue('latitude', newCoords[0], { shouldValidate: true })
      setValue('longitude', newCoords[1], { shouldValidate: true })
      prevFormCoordsRef.current = [newCoords[0], newCoords[1]]
      isUpdatingFromMapRef.current = false
    }
  }, [newCoords, setValue])

  useEffect(() => {
    if (isUpdatingFromMapRef.current) {
      return
    }

    const currentLat = getValues('latitude')
    const currentLng = getValues('longitude')

    if (
      currentLat !== undefined &&
      currentLng !== undefined &&
      currentLat !== null &&
      currentLng !== null
    ) {
      const latNum =
        typeof currentLat === 'number' ? currentLat : Number(currentLat)
      const lngNum =
        typeof currentLng === 'number' ? currentLng : Number(currentLng)

      if (!isNaN(latNum) && !isNaN(lngNum)) {
        const updatedCoords = [latNum, lngNum]
        const prevCoords = prevFormCoordsRef.current

        if (
          Math.abs(prevCoords[0] - updatedCoords[0]) > 0.000001 ||
          Math.abs(prevCoords[1] - updatedCoords[1]) > 0.000001
        ) {
          prevFormCoordsRef.current = [updatedCoords[0], updatedCoords[1]]
          setNewCoords([updatedCoords[0], updatedCoords[1]])
        }
      }
    }
  }, [watchedLatitude, watchedLongitude, getValues])
  const [updateTrafficAccident, { isLoading: isSubmitting }] =
    useUpdateTrafficAccidentMutation()
  const handleChangeTime = (start: string, _end: string) => {
    setTimeState(start)
  }
  const onSaveBtnClick = async () => {
    const isValid = await trigger()
    if (!isValid) {
      notifyError('Исправьте ошибки в форме')
      return
    }
    setOpenDialogSave(true)
  }
  const onSubmit = async (dataForm: DtpFormFields) => {
    try {
      setOpenDialogSave(false)

      const combineDateAndTime = (
        dateString: string | null | undefined | Dayjs,
        timeString: string
      ): string | null => {
        if (!dateString) return null

        let datePart: string
        if (dayjs.isDayjs(dateString)) {
          datePart = dateString.format('YYYY-MM-DD')
        } else {
          datePart = String(dateString).split('T')[0]
        }

        let timePart = timeString.trim()

        if (timePart.length === 5) {
          timePart = `${timePart}:00`
        } else if (timePart.length !== 8) {
          timePart = timePart.padEnd(8, ':00').slice(0, 8)
        }

        return `${datePart}T${timePart}.000Z`
      }

      const requestData: UpdateTrafficAccidentRequest = {
        id: id ? parseInt(id, 10) : 0,
        number: parseInt(dataForm.number || '0', 10),
        accidentDate: combineDateAndTime(dataForm.accidentDate, timeState),
        regionId: dataForm.regionId || 0,
        district: dataForm.district || null,
        road: roadState || null,
        roadKilometer: dataForm.roadKilometer ?? null,
        roadMeter: dataForm.roadMeter ?? null,
        latitude: dataForm.latitude || 0,
        longitude: dataForm.longitude || 0,
        typeId: dataForm.typeId === '' ? null : dataForm.typeId || null,
        areaTypeId:
          dataForm.areaTypeId === '' ? null : dataForm.areaTypeId || null,
        lightingTypeId:
          dataForm.lightingTypeId === ''
            ? null
            : dataForm.lightingTypeId || null,
        dead: dataForm.dead ?? null,
        deadChildren: dataForm.deadChildren ?? null,
        injured: dataForm.injured ?? null,
        injuredChildren: dataForm.injuredChildren ?? null,
      }

      const removeNullFields = <T extends Record<string, unknown>>(
        obj: T
      ): Partial<T> => {
        const result: Partial<T> = {}
        for (const key in obj) {
          if (obj[key] !== null) {
            result[key] = obj[key]
          }
        }
        return result
      }

      const cleanedRequestData = removeNullFields(
        requestData
      ) as UpdateTrafficAccidentRequest

      const res = await updateTrafficAccident(cleanedRequestData).unwrap()
      if (res.success) {
        notifySuccess('Данные успешно сохранены')
        refetch()
      }
    } catch (error) {
      console.log(error)
    }
  }
  const centerCoords = useMemo(
    () => [inputsData?.latitude || 0, inputsData?.longitude || 0],
    [inputsData?.latitude, inputsData?.longitude]
  )

  return (
    <>
      <Dialog
        message='Сохранить внесенные изменения?'
        open={openDialogSave}
        handleClose={() => setOpenDialogSave(false)}
        handleAgree={() => {
          if (Object.keys(formState.errors).length >= 1) {
            notifyError('Исправте ошибки в форме')
          }
          handleSubmit(onSubmit)()
        }}
      />
      <Box
        flex={1}
        display='flex'
        flexDirection={{ xss: 'column', md: 'row' }}
      >
        <Box
          // border='1px solid #0072BC'
          // className={'map-container'}
          // sx={{ height: '600px' }}
          display='flex'
          width={'600px'}
          // width={{ xss: '100%', md: '50%' }}
          border='1px solid #0072BC'
          mt={{ xss: 0, lg: '35px', xlgx: '-48px' }}
          height={{
            xss: '100%',
            mdx: '100%',
            lg: 'calc(100% - 35px)',
            xlgx: 'calc(100% + 48px)',
          }}
          maxHeight={{ xss: '50%', md: 'calc(100% + 48px)' }}
        >
          <MapDTPProvider
            isHomePage={false}
            newCoords={newCoords}
            setNewCoords={handleChangeCoords}
            centerCoords={centerCoords}
            disabled={isDisabled}
          />
        </Box>
        <Box
          width={'500px'}
          maxHeight={'calc(100vh - 245px)'}
          overflow={'auto'}
          display='flex'
          flex={{ xss: 1 }}
          px={1}
        >
          <form
            style={{ width: '100%' }}
            onSubmit={(e) => e.preventDefault()}
          >
            <Typography
              variant='h6'
              fontSize={18}
              color='primary'
            >
              Информация о ДТП
            </Typography>
            <Grid {...gridContainerProps}>
              <Grid {...gridItemProps}>
                <Input
                  name='number'
                  type='text'
                  label='Номер'
                  control={control}
                  disabled={isDisabled}
                />
              </Grid>
              <Grid {...gridItemProps}>
                <DatePickers
                  control={control}
                  name='accidentDate'
                  label='Дата'
                  disabled={isDisabled}
                />
              </Grid>
              <Grid {...gridItemProps}>
                <TimePicker
                  brightnessStartTime={getTimeFromDate(
                    inputsData?.accidentDate
                  )}
                  onChange={handleChangeTime}
                  disabled={isDisabled}
                />
              </Grid>
              <Grid {...gridItemProps}>
                <UnitSelect
                  disabled={isDisabled}
                  items={inputsData?.types}
                  name='typeId'
                  label='Тип ДТП'
                  control={control}
                />
              </Grid>
              <Grid {...gridItemProps}>
                <UnitSelect
                  disabled={isDisabled}
                  items={inputsData?.regions}
                  name='regionId'
                  label='Регион'
                  control={control}
                />
              </Grid>
              <Grid {...gridItemProps}>
                <Input
                  name='district'
                  type='string'
                  label='Район'
                  control={control}
                  disabled={isDisabled}
                />
              </Grid>
            </Grid>
            <Grid {...gridContainerProps}>
              <Grid
                item
                xss={12}
                mdx={12}
                xl={12}
                xl4={12}
              >
                <Asynchronous
                  value={roadState}
                  onChange={setRoadState}
                  disabled={isDisabled}
                />
              </Grid>
              <Grid {...gridItemProps}>
                <Input
                  name='roadKilometer'
                  type='number'
                  label='Километр'
                  control={control}
                  disabled={isDisabled}
                />
              </Grid>
              <Grid {...gridItemProps}>
                <Input
                  name='roadMeter'
                  type='number'
                  label='Метр'
                  control={control}
                  disabled={isDisabled}
                />
              </Grid>
              <Grid {...gridItemProps}>
                <Input
                  name='latitude'
                  type='number'
                  label='Широта'
                  control={control}
                  allowDecimal={true}
                  maxDecimalPlaces={15}
                  disabled={isDisabled}
                />
              </Grid>
              <Grid {...gridItemProps}>
                <Input
                  name='longitude'
                  type='number'
                  label='Долгота'
                  control={control}
                  allowDecimal={true}
                  maxDecimalPlaces={15}
                  disabled={isDisabled}
                />
              </Grid>
            </Grid>
            <Grid {...gridContainerProps}>
              <Grid {...gridItemProps}>
                <Input
                  name='dead'
                  type='number'
                  label='Погибло'
                  control={control}
                  disabled={isDisabled}
                />
              </Grid>
              <Grid {...gridItemProps}>
                <Input
                  name='deadChildren'
                  type='number'
                  label='Погибло детей'
                  control={control}
                  disabled={isDisabled}
                />
              </Grid>
              <Grid {...gridItemProps}>
                <Input
                  name='injured'
                  type='number'
                  label='Ранено'
                  control={control}
                  disabled={isDisabled}
                />
              </Grid>
              <Grid {...gridItemProps}>
                <Input
                  name='injuredChildren'
                  type='number'
                  label='Ранено детей'
                  control={control}
                  disabled={isDisabled}
                />
              </Grid>
              <Grid {...gridItemProps}>
                <UnitSelect
                  disabled={isDisabled}
                  items={inputsData?.lightingTypes}
                  name='lightingTypeId'
                  label='Освещение'
                  control={control}
                />
              </Grid>
              <Grid {...gridItemProps}>
                <UnitSelect
                  disabled={isDisabled}
                  items={inputsData?.areaTypes}
                  name='areaTypeId'
                  label='Участок'
                  control={control}
                />
              </Grid>
            </Grid>

            {currentUserType === UserTypes.superAdmin ? (
              <Box
                display='flex'
                alignItems='flex-start'
                justifyContent='flex-end'
                gap={2}
                mr={{ xss: 0.5, lg: 2 }}
                pt={1}
              >
                <>{id && <DeleteDeviceButton deviceId={id} />}</>

                <LoadingButton
                  variant='outlined'
                  onClick={onSaveBtnClick}
                  // disabled={!formChanged}
                >
                  <span>Сохранить</span>
                </LoadingButton>
              </Box>
            ) : null}
          </form>
        </Box>
      </Box>
    </>
  )
}

export default FeaturesDTPForm
